import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBasket2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBasket2"><Path d="M7.3602 8L9.22721 3.33248L7.83449 2.77539L5.74465 8H1.85938L4.12024 21H19.8819L22.1428 8H18.26L16.1701 2.77539L14.7774 3.33248L16.6444 8H7.3602Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBasket2;
